import { css } from "@emotion/react";

export const nonSelectable = css`
  user-select: none; /* Standard syntax */
  -webkit-user-select: none; /* Chrome, Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

export const notDraggable = css`
  -webkit-user-drag: none; /* Chrome, Safari, Opera */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
  user-drag: none; /* Standard syntax */
`;
